module.exports = __webpack_public_path__ + "static/media/pop2.07474e14.wav";